// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg-view {\n    background-color: #f5f5f5;\n}\n.printEffect{\n    -webkit-filter: blur(5px);\n    -moz-filter: blur(5px);\n    -o-filter: blur(5px);\n    -ms-filter: blur(5px);\n    filter: blur(5px);\n    /* width: 100px; */\n    height: 100px;\n    background-color: #ccc;\n}\n", ""]);
// Exports
module.exports = exports;
